import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Sidebar from "./Sidebar";
import NotificationBell from "./NotificationBell";
import NewTaskLoginPopup from "./NewTaskLoginPopup";
import "../css/layout.css";

const PAGE_TITLES = {
  "/dashboard":   "Dashboard",
  "/leads":       "Leads",
  "/leads-table": "Leads Table",
  "/properties":  "Properties",
  "/site-visits": "Site Visits",
  "/deals":       "Deals",
  "/payments":    "Payments",
  "/documents":   "Documents",
  "/tasks":       "Tasks",
  "/analytics":   "Analytics",
  "/call-logs":   "Call Logs",
  "/mis":         "MIS Report",
  "/users":       "User Management",
};

function formatDate() {
  return new Date().toLocaleDateString("en-IN", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

export default function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  const basePath  = "/" + location.pathname.split("/")[1];
  const pageTitle = PAGE_TITLES[basePath] || "ZENREAL ESTATES CRM";

  return (
    <div className="layout">
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <div className="content-wrapper">
        {/* ── Desktop top bar ── */}
        <div className="topbar">
          <div className="topbar-left">
            <h1 className="topbar-page-title">{pageTitle}</h1>
            <div className="topbar-divider" />
            <p className="topbar-breadcrumb">ZENREAL ESTATES CRM</p>
          </div>
          <div className="topbar-right">
            <span className="topbar-date-chip">{formatDate()}</span>
            <NotificationBell />
          </div>
        </div>

        {/* ── Mobile header ── */}
        <div className="mobile-header">
          <button className="menu-btn" onClick={() => setSidebarOpen(true)}>☰</button>
          <h2>{pageTitle}</h2>
        </div>

        {/* ── Page content ── */}
        <div className="page-content">
          <Outlet />
        </div>
      </div>

      <ToastContainer position="top-right" autoClose={4000} newestOnTop />

      {/* One-time pop-up after login announcing newly assigned tasks */}
      <NewTaskLoginPopup />
    </div>
  );
}
